module.exports = __webpack_public_path__ + "media/images/icons/laugh-ef19e136b1e126c5e2466e49f27b5f70.png";